/**
 * Gift Card Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Gift Card template.
 */

import $ from 'jquery'
import QRCode from 'qrcode'

const SELECTORS = {
    qrCode: '#QrCode',
    printButton: '#PrintGiftCard',
    giftCardCode: '.giftcard__code'
}

function selectText(evt) {
    const text = document.getElementById(evt.data.element)
    let range = ''

    if (document.body.createTextRange) {
        range = document.body.createTextRange()
        range.moveToElementText(text)
        range.select()
    } else if (window.getSelection) {
        const selection = window.getSelection()
        range = document.createRange()
        range.selectNodeContents(text)
        selection.removeAllRanges()
        selection.addRange(range)
    }
}

function makeQRCode() {
    const $qrCode = $(SELECTORS.qrCode)
    if ($qrCode.length) {
        const data = $qrCode.data('identifier')
        QRCode.toDataURL(data).then((url) => {
            const $qrImg = $('<img />')
            $qrImg.attr({
                src: url,
                width: 150,
                height: 150
            })
            $qrCode.append($qrImg)
        })
    }
}

$(document).ready(() => {
    // print the page
    $(SELECTORS.printButton).on('click', () => {
        window.print()
    })

    // Auto-select gift card code on click, based on ID passed to the function
    $(SELECTORS.giftCardCode).on('click', { element: 'GiftCardDigits' }, selectText)

    // build QR code from code string
    makeQRCode()
})
